<template>
  <v-container
    id="customers-view"
    fluid
    tag="section"
  >
    <material-card dark icon="mdi-clipboard-text" icon-small :title="$t('banners_list')" color="accent">
      <template v-slot:headActions>
        <app-btn color="primary" dark class="ml-2" to="/settings/landing/banners/new">
          {{ $t('new_banner') }}
        </app-btn>
      </template>
      <v-data-table :headers="headers" :loading="loading" :items="items">
        <template v-slot:body="{ items }">
          <banner v-for="item in items" :key="item.id" :item="item" @removed="removeItem" />
        </template>
      </v-data-table>
    </material-card>
  </v-container>
</template>
<script>
import { mapActions } from 'vuex'
import Banner from '@/components/Settings/Landing/Banners/Banner'

export default {
  name: 'BannersList',
  components: {
    Banner,
  },
  data: () => ({
    loading: false,
    headers: [
      { text: 'ID', align: 'center', width: '20%', value: 'id' },
      { text: 'Type', align: 'center', width: '20%', value: 'type' },
      { text: 'Is New', align: 'center', width: '20%', value: 'new' },
      { text: 'Start Date', align: 'center', width: '20%', value: 'start_date' },
      { text: 'End Date', align: 'center', width: '20%', value: 'end_date' },
      { text: 'Action', align: 'center', width: '20%', sortable: false, value: '' },
    ],
    items: [],
  }),
  mounted () {
    this.loading = true
    this.loadBannersList()
      .then(result => {
        this.items = result.data
      })
      .finally(() => {
        this.loading = false
      })
  },
  methods: {
    ...mapActions({
      loadBannersList: 'settings/landing/banners/loadBanners',
    }),
    removeItem (itemId) {
      const idx = this.items.findIndex(i => i.id === itemId)
      this.items.splice(idx, 1)
    },
  },
}
</script>
